import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bitcoinFormat',
  standalone: true,
})
export class BitcoinFormatPipe implements PipeTransform {
  transform(value: any): string {
    if (isNaN(value) || value <= 0) {
      return '0.0000000000';
    }

    const numValue = Number(value);
    const integerPartLength = Math.floor(numValue).toString().length;

    const decimalPlaces = Math.max(10 - integerPartLength, 2);

    return numValue.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
